import React, { useState, useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import Loader from './Loader';
import './style.scss';

const LoadMore = ({ loadMore, autoload = false, triggerRef }) => {
    const [loading, setLoading] = useState(false);
    const [autoLoad, setAutoLoad] = useState(autoload);

    const containerRef = useRef(null);

    const onLoadMore = () => {
        setLoading(true);

        loadMore()
            .then(() => {
                setLoading(false);
                !autoLoad && setAutoLoad(true);
            })
            .catch(() => {
                setLoading(false);

                // So we won't continue to spam with loads if api dies, Mitigate to user action again
                setAutoLoad(false);
            });
    };

    useIntersectionObserver([containerRef?.current, triggerRef?.current], ([containerEntry, triggerEntry]) => {
        const isIntersecting = containerEntry?.isIntersecting || triggerEntry?.isIntersecting;
        if (loading || !isIntersecting || !loadMore || !autoLoad) {
            return;
        }
        onLoadMore();
    });

    if (!loadMore) {
        return null;
    }

    return (
        <footer className={cn('col-12-xs flex-center listing-load-more', { 'auto-load': autoLoad })} ref={containerRef}>
            {!loading ? (
                <Button color="blue" fill="ghost" onClick={onLoadMore}>
                    <I18n k="variations_display.load_more" />
                </Button>
            ) : (
                <Loader />
            )}
        </footer>
    );
};

LoadMore.propTypes = {
    loadMore: PropTypes.func,
    autoload: PropTypes.bool,
    triggerRef: PropTypes.object,
};

export default LoadMore;
